// extracted by mini-css-extract-plugin
module.exports = {"link":"Text_link__2NxtN"};